import { useEffect, useState } from 'react'

import { getUkCurrencyOptions } from '../../../../../api'
import { EMPTY_OBJECT } from '../../../../../constants/common'
import { useApi, useNotification } from '../../../../../hooks'

import { toCurrencyOptions } from './useUserProfilePageWidgetListInfoOptions.utils'

export function useUserProfilePageWidgetListInfoOptions({ canEdit }) {
  const [options, setOptions] = useState(EMPTY_OBJECT)

  const api = useApi()

  const { handleAddErrorNotification } = useNotification()

  useEffect(() => {
    if (canEdit) {
      api
        .call(({ options }) => getUkCurrencyOptions({ options }))
        .then(currency => {
          if (currency) {
            setOptions({ currency: toCurrencyOptions(currency.data) })
          }
        })
        .catch(() => {
          setOptions(EMPTY_OBJECT)
          handleAddErrorNotification('Error.CommonApiRequestFailKey')
        })
    }

    return () => {
      api.abort()
    }
  }, [canEdit])

  return options
}
